import { useState, useCallback } from 'react';

interface ErrorState {
  hasError: boolean;
  error: Error | null;
}

export const useErrorBoundary = () => {
  const [errorState, setErrorState] = useState<ErrorState>({
    hasError: false,
    error: null,
  });

  const resetError = useCallback(() => {
    setErrorState({ hasError: false, error: null });
  }, []);

  const captureError = useCallback((error: Error) => {
    setErrorState({ hasError: true, error });
  }, []);

  return {
    hasError: errorState.hasError,
    error: errorState.error,
    resetError,
    captureError,
  };
};
